export default __webpack_public_path__ + "static/media/Slider9.7c3585e3.jpg";